import { ChangeDetectorRef, Component, DestroyRef, inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslateModule } from '@ngx-translate/core';

import { Globals } from '@core/globals';
import { ContentComponent } from '@atoms/content/content.component';
import { SmallTitleComponent } from '@atoms/small-title/small-title.component';
import { UnderlineLinkComponent } from '@atoms/underline-link/underline-link.component';
import { TitleComponent } from '@atoms/title/title.component';
import { CardComponent } from '@molecules/card/card.component';
import { CardLoaderComponent } from '@molecules/card/card-loader/card-loader.component';
import { SliderComponent } from '@molecules/slider/slider.component';
import { SliderItemComponent } from '@molecules/slider/slider-item/slider-item.component';
import { CarCardComponent } from '@organisms/car-card/car-card.component';
import { RecommenderService } from '@services/recommender.service';
import { GtmService } from '@services/gtm.service';
import { ListItem } from '@models/list.model';

@Component({
  selector: 'app-recommender',
  imports: [NgClass, TranslateModule, ContentComponent, SmallTitleComponent, UnderlineLinkComponent, TitleComponent, CardComponent, CardLoaderComponent, SliderComponent, SliderItemComponent, CarCardComponent],
  templateUrl: './recommender.component.html',
  styleUrl: './recommender.component.scss',
})
export class RecommenderComponent implements OnInit, OnChanges {
  private cd = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);
  public globals = inject(Globals);
  private recommenderService = inject(RecommenderService);
  //private gtmService = inject(GtmService);
  @Input() title?: string;
  @Input('title-color') titleColor: 'default' | 'white' | 'grey' = 'default';
  @Input('title-large-desktop') titleLargeDesktop: boolean = false;
  @Input() type: 'default' | 'new-cars' | 'coming-soon' = 'default';
  @Input('list-link') listLink: boolean = false;
  @Input('custom-data') customData?: ListItem[] = [];
  @Input('price-from') priceFrom?: number;
  public loaded: boolean = false;
  public data?: ListItem[];

  changed(): void {
    //this.gtmService.pushGtmPageType({ event: 'click_recom_listovani' }); // TODO: Fix
  }

  ngOnInit(): void {
    if (this.type === 'new-cars') {
      this.recommenderService
        .getNewCarsRecommenderData()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          this.data = response;
          this.cd.detectChanges();
        });
    } else if (this.type === 'coming-soon') {
      this.recommenderService
        .getComingSoonRecommender()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          this.data = response;
          this.cd.detectChanges();
        });
    } else {
      this.recommenderService
        .getRecommenderData()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          this.data = response;
          this.cd.detectChanges();
        });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData']) {
      if (changes['customData'].currentValue !== undefined) {
        this.data = changes['customData'].currentValue;
        this.loaded = true;
        this.cd.detectChanges();
      } else {
        this.loaded = false;
        this.data = undefined;
      }
    }
  }
}
